import * as React from "react";

export const SvgArrowStraightRight = ({ "data-testid": dataTestId = null, ...props }) => (
	<svg width={15} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" data-testid={dataTestId} {...props}>
		<path
			d="M12.946 6.285 9.613 2.953a.52.52 0 0 0-.737.736l2.444 2.444h-8.9a.52.52 0 0 0 0 1.042h8.9L8.877 9.618a.52.52 0 1 0 .736.737l3.333-3.333a.52.52 0 0 0 0-.737Z"
			fill="#595959"
		/>
	</svg>
);
